var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelAnytime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6701_2187)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6701_2187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V60H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6701_2187)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6701_2187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 59,
    height: 59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H59.333V59.333H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6701_2187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.167 1C24.3985 1 18.7596 2.71053 13.9633 5.91529C9.16703 9.12004 5.42875 13.6751 3.22122 19.0044C1.01368 24.3338 0.436037 30.198 1.56133 35.8556C2.68663 41.5133 5.46432 46.7101 9.54316 50.7891C13.622 54.8681 18.8188 57.646 24.4764 58.7715C30.134 59.8969 35.9982 59.3195 41.3276 57.1122C46.657 54.9048 51.2122 51.1667 54.4171 46.3705C57.6221 41.5743 59.3328 35.9354 59.333 30.167C59.333 22.4316 56.2602 15.013 50.7905 9.54317C45.3209 4.07333 37.9024 1.00027 30.167 1ZM30.167 57.874C24.6868 57.8742 19.3296 56.2493 14.7729 53.2048C10.2162 50.1603 6.6646 45.8329 4.56733 40.7699C2.47005 35.7068 1.92125 30.1356 2.99034 24.7607C4.05943 19.3858 6.69838 14.4486 10.5735 10.5735C14.4486 6.69839 19.3858 4.05944 24.7607 2.99035C30.1356 1.92127 35.7068 2.47006 40.7698 4.56734C45.8329 6.66461 50.1602 10.2162 53.2048 14.7729C56.2493 19.3296 57.8742 24.6868 57.874 30.167C57.8655 37.5128 54.9437 44.5552 49.7494 49.7495C44.5552 54.9437 37.5127 57.8655 30.167 57.874Z",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8599 20.7721L25.9399 38.6901L17.5939 30.6961C17.4528 30.5709 17.2686 30.5052 17.0801 30.5129C16.8916 30.5206 16.7134 30.601 16.583 30.7374C16.4526 30.8738 16.3801 31.0554 16.3809 31.244C16.3816 31.4327 16.4554 31.6138 16.5869 31.7491L25.4469 40.2361C25.5847 40.3678 25.7685 40.4404 25.9591 40.4383C26.1497 40.4363 26.332 40.3598 26.4669 40.2251L44.8869 21.8031C44.9546 21.7354 45.0083 21.6551 45.0449 21.5666C45.0815 21.4782 45.1004 21.3834 45.1004 21.2876C45.1004 21.1919 45.0815 21.0971 45.0449 21.0086C45.0083 20.9202 44.9546 20.8398 44.8869 20.7721C44.8192 20.7044 44.7388 20.6507 44.6504 20.6141C44.5619 20.5775 44.4671 20.5586 44.3714 20.5586C44.2756 20.5586 44.1808 20.5775 44.0924 20.6141C44.0039 20.6507 43.9236 20.7044 43.8559 20.7721",
    fill: "#040504"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6701_2187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAnytime);
export default __webpack_public_path__ + "static/media/cancel-anytime.0332165dd81cd49e45d3d0aad1674382.svg";
export { ForwardRef as ReactComponent };